"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Po = exports.To = exports.Go = exports.Mo = exports.Ko = exports.Bytes = void 0;
exports.showBytes = showBytes;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
exports.Bytes = zod_1.z.number(); // number of bytes
exports.Ko = 1000;
exports.Mo = 1000 * exports.Ko;
exports.Go = 1000 * exports.Mo;
exports.To = 1000 * exports.Go;
exports.Po = 1000 * exports.To;
function showBytes(bytes) {
    if (bytes > exports.Po)
        return `${(0, utils_1.prettyNumber)(bytes / exports.Po)} Po`;
    if (bytes > exports.To)
        return `${(0, utils_1.prettyNumber)(bytes / exports.To)} To`;
    if (bytes > exports.Go)
        return `${(0, utils_1.prettyNumber)(bytes / exports.Go)} Go`;
    if (bytes > exports.Mo)
        return `${(0, utils_1.prettyNumber)(bytes / exports.Mo)} Mo`;
    if (bytes > exports.Ko)
        return `${(0, utils_1.prettyNumber)(bytes / exports.Ko)} ko`;
    return `${Math.round(bytes)} bytes`;
}
//# sourceMappingURL=bytes.js.map